module.exports = __webpack_public_path__ + "media/images/page/gift-flow04-f5e3c7ee14c443f1fd784802e7ef72b5.jpg";